import { InjectionToken } from '@angular/core';
import { DynamicComponentMap } from '../interfaces/dynamic-filter.interface';

export const DYNAMIC_FILTER_COMPONENTS = new InjectionToken<DynamicComponentMap[]>('Components for the dynamic filter component');
